// Invoice Model
class Invoice {
  constructor(data = {}) {
    this.id = data.id || data._id || null;
    this.invoiceId = data.invoiceId || '';
    this.orderId = data.orderId || null; // sales order se convert hua to link
    this.customerName = data.customerName || '';
    this.email = data.email || '';
    this.phone = data.phone || '';
    this.company = data.company || '';
    this.items = data.items || [];
    this.invoiceDate = data.invoiceDate || new Date().toISOString();
    this.dueDate = data.dueDate || '';
    this.status = data.status || 'Draft'; // Draft, Sent, Paid, Partial, Overdue, Cancelled
    this.totalAmount = data.totalAmount || 0;
    this.paidAmount = data.paidAmount || 0;
    this.notes = data.notes || '';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
  }

  // Kitna balance bacha hai
  getBalanceAmount() {
    return this.totalAmount - this.paidAmount;
  }

  getStatusColor() {
    const colors = {
      Draft: '#64748b',
      Sent: '#3b82f6',
      Paid: '#10b981',
      Partial: '#f59e0b',
      Overdue: '#ef4444',
      Cancelled: '#94a3b8',
    };
    return colors[this.status] || '#64748b';
  }

  // Due date nikal chuki hai aur balance bacha hai to overdue
  isOverdue() {
    if (!this.dueDate) return false;
    return new Date(this.dueDate) < new Date() && this.getBalanceAmount() > 0;
  }

  getDaysOverdue() {
    if (!this.isOverdue()) return 0;
    const diff = new Date() - new Date(this.dueDate);
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  }
}

export default Invoice;